import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
// eslint-disable-next-line @typescript-eslint/unbound-method -- Complaining about `this` in Chakra functions?
const { definePartsStyle , defineMultiStyleConfig  } = createMultiStyleConfigHelpers(tableAnatomy.keys);
const defaultProps = {
    size: 'sm',
    variant: 'striped'
};
const md = defineStyle({
    fontSize: 'l',
    py: 2
});
const sm = defineStyle({
    fontSize: 'm',
    py: 2
});
const sizes = {
    md: definePartsStyle({
        td: md,
        th: md
    }),
    sm: definePartsStyle({
        td: sm,
        th: sm
    })
};
const variants = {
    striped: definePartsStyle({
        th: {
            color: 'text.primary'
        }
    })
};
export const Table = defineMultiStyleConfig({
    defaultProps,
    sizes,
    variants
});

//# sourceMappingURL=table.js.map